module.exports = __webpack_public_path__ + "static/media/sf_1300.0e030cca60da587fd5c7fe6f724bc30b.png";